import { ProductImageRendition } from "@omni/types/api/product/shared/enums/productImageRendition.enum";
import { Media } from "@omni/types/api/shared/bff/media.model";
import { ProductImageRenditions } from "@omni/types/components/product/productImageRenditions.type";
import { BreakpointMinSizes } from "@omni/types/enums/breakPoint.enum";

import { ProductImage } from "@/components/Product/ProductImage/imageWrapper/imageWrapper.component";
import {
    useBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

type ProductImageWrapperProps = {
    title: string | undefined;
    medias: null | Array<Media>;
    isEcoChequesAccepted: boolean;
    hasInstallationService: boolean;
    renditions?: ProductImageRenditions;
    className?: string;
    lazyLoad?: boolean;
    parentFit?: boolean;
};

const _ProductImageWrapper = ({
    title,
    medias,
    isEcoChequesAccepted,
    hasInstallationService,
    renditions,
    className,
    lazyLoad = false,
    parentFit = false
}: ProductImageWrapperProps) => {
    const { breakpoints } = useBreakpoint();

    const activeRendition = (Object.keys(breakpoints) as BreakpointMinSizes[])
        .reverse()
        .find((k) => breakpoints[k]);

    const rendition = activeRendition
        ? renditions?.[activeRendition]
        : renditions?.defaultRendition || ProductImageRendition.SM;

    return (
        <ProductImage
            title={title}
            medias={medias}
            isEcoChequesAccepted={isEcoChequesAccepted}
            hasInstallationService={hasInstallationService}
            rendition={rendition}
            className={className}
            lazyLoad={lazyLoad}
            parentFit={parentFit}
        />
    );
};

export const ProductImageWrapper = withBreakpoints(_ProductImageWrapper);
